export function extract_filename(storjFilename) {
    return storjFilename.split("___")[1]
}